const ErrorCodes = {
  S_AGENT_BUSY: '21',
  S_NO_AGENT_ONLINE: '25',
  S_EXCEED_QUEUE_LENGTH: '36',
  S_SEND_MESSAGE_ERROR: '28',

  OUT_WORKING_TIME: 'out_working_time',
  NO_SKILLGROUP_ID: 'no_skillgroup_id',
  LOGIN_FAILED: 'login_failed',
  DISPATCH_FAILED: 'dispatch_failed',
  NOT_CONNECTED: 'not_connected',
  NO_CONNECTION: 'no_connection',

  SEND_MESSAGE_FAILED: 'send_message_failed',
  UPLOAD_FAILED: 'upload_failed',
  SENT_IMAGE_FAILED: 'send_image_failed',
  SENT_FILE_FAILED: 'send_file_failed',
  EXCEED_FILE_SIZE: 'exceed_file_size',
  INVALID_IMAGE_FILE: 'invalid_image_file',
  INVALID_DOC_FILE: 'invalid_doc_file',

  GET_EVALUATION_FAILED: 'get_evaluation_failed',
  SUBMIT_EVALUATION_FAILED: 'submit_evaluation_failed',

  UNKNOWN_ERROR: 'unknown_error',

  NO_PERMISSION: 'NO_PERMISSION',
};

export default ErrorCodes;



// WEBPACK FOOTER //
// ./src/app/const/errorCodes.js